import { render, staticRenderFns } from "./AppStoreButton.vue?vue&type=template&id=335f0fcc&scoped=true"
import script from "./AppStoreButton.vue?vue&type=script&lang=ts"
export * from "./AppStoreButton.vue?vue&type=script&lang=ts"
import style0 from "./AppStoreButton.vue?vue&type=style&index=0&id=335f0fcc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335f0fcc",
  null
  
)

export default component.exports